// apps/web/src/components/settlements/SettlementManager.tsx
// Settlement lifecycle management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Settlement } from '../../types/platform.js';

export function SettlementManager() {
  return (
    <ManagerPage
      title="Settlements"
      listPath="/api/v1/settlements"
      listKey="settlements"
      createLabel="New Settlement"
      className="settlements-manager"
      renderItem={(raw) => {
        const s = raw as Settlement;
        return (
          <div className="manager-card" key={s.id}>
            <h3>{s.netAmount} {s.currency}</h3>
            <p className="status-badge">{s.status}</p>
            <p>Gross {s.grossAmount} · Fees {s.feesAmount} · Tax {s.taxAmount}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-primary">Process</button>
              <button className="btn btn-outline">Split</button>
            </div>
          </div>
        );
      }}
    />
  );
}